export const ENDPOINTS: any = {
  loginEmployer: "/employers/auth",
  loginEmployee: "/employees/auth",
  employers: "/employers",
  employees: "/employees",
  getStores: "/stores/owners",
  store: "/stores",
  products: "/products",
  categories: "/categories",
  catelogs: "/catalogs",
  sales: "/sales",
  tax: "/tax",
} as const;
